"use client";

import styled from "styled-components";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const EstimateSpan = styled.span`
  cursor: help;
`;

const EstimateBadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 9999px;
  background-color: var(--color-warning-border);
  color: var(--color-warning-text);
  cursor: help;
`;

const TooltipTitle = styled.p`
  font-weight: 500;
  margin: 0 0 4px 0;
`;

const TooltipText = styled.p`
  font-size: 12px;
  color: var(--color-text-tertiary);
  margin: 0;
`;

interface EstimateIndicatorProps {
  value: string | number;
  isEstimate: boolean;
  tooltipText?: string;
}

export function EstimateIndicator({
  value,
  isEstimate,
  tooltipText = "Предварительные данные, будут уточнены после отчёта о реализации",
}: EstimateIndicatorProps) {
  if (!isEstimate) {
    return <span>{value}</span>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <EstimateSpan>~{value}</EstimateSpan>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

interface EstimateBadgeProps {
  estimateDates: string[];
  totalDays: number;
}

export function EstimateBadge({ estimateDates, totalDays }: EstimateBadgeProps) {
  if (!estimateDates || estimateDates.length === 0) {
    return null;
  }

  const estimateCount = estimateDates.length;
  const percentage = totalDays > 0 ? Math.round((estimateCount / totalDays) * 100) : 0;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <EstimateBadgeWrapper>
            ~{estimateCount} дн. ({percentage}%)
          </EstimateBadgeWrapper>
        </TooltipTrigger>
        <TooltipContent>
          <TooltipTitle>Предварительные данные</TooltipTitle>
          <TooltipText>
            {estimateCount} из {totalDays} дней содержат оценочные данные.
            Точные цифры появятся после отчёта о реализации.
          </TooltipText>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
